import { render, staticRenderFns } from "./EditarModeloDocumento.vue?vue&type=template&id=822f7a4e"
import script from "./EditarModeloDocumento.vue?vue&type=script&lang=js"
export * from "./EditarModeloDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports